export default {
  createTag: 'Create Tag',
  createSubtitle: 'Add a new tag to categorize resources',
  editTag: 'Edit Tag',
  editTitle: 'Edit Tag',
  editSubtitle: 'Update tag information',
  createSuccess: 'Tag created successfully',
  createError: 'Failed to create tag',
  updateSuccess: 'Tag updated successfully',
  updateError: 'Failed to update tag',
  loadError: 'Failed to load tag',
  notFound: 'Tag not found',
  tagsAdmin: {
    form: {
      name: 'Name',
      namePlaceholder: 'Enter tag name',
      description: 'Description',
      descriptionPlaceholder: 'Enter tag description (optional)',
      color: 'Color',
      preview: 'Preview'
    },
    validation: {
      nameRequired: 'Name is required'
    },
    createTitle: 'Create Tag',
    editTitle: 'Edit Tag',
    deleteTitle: 'Delete Tag',
    createSuccess: 'Tag created successfully',
    updateSuccess: 'Tag updated successfully',
    deleteSuccess: 'Tag deleted successfully',
    createError: 'Failed to create tag',
    updateError: 'Failed to update tag',
    deleteError: 'Failed to delete tag',
    deleteConfirmation: 'Are you sure you want to delete this tag? This action cannot be undone.'
  }
};
